import { Box, Paper, Typography, IconButton, Popover } from '@material-ui/core';
import React, { ReactNode, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InfoOutlined } from '@material-ui/icons';

interface AnalyticsPanelProps {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
  InfoComponent?: () => ReactNode;
}

const AnalyticsPanel = ({ title, action, children, InfoComponent }: AnalyticsPanelProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleInfoClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Paper className={classes.root}>
      <Box className={classes.container}>
        <Box className={classes.titleContainer}>
          {title && (
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              className={classes.leftTitle}
              style={{ gap: '0.5em' }}
            >
              <Box whiteSpace="nowrap">
                <Typography variant="subtitle2" gutterBottom>
                  {title}
                </Typography>
              </Box>
              {InfoComponent && (
                <>
                  <IconButton size="small" onClick={handleInfoClick}>
                    <InfoOutlined fontSize="small" color="primary" />
                  </IconButton>
                  <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleInfoClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <InfoComponent />
                  </Popover>
                </>
              )}
            </Box>
          )}
          {action && <Box>{action}</Box>}
        </Box>
        {children}
      </Box>
    </Paper>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: 1,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: theme.spacing(1.5),
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
  leftTitle: {
    flex: 1,
    textAlign: 'left',
  },
  centerTitle: {
    flex: 1,
    textAlign: 'center',
  },
  rightTitle: {
    flex: 1,
    textAlign: 'right',
  },
}));

export default AnalyticsPanel;
